import { branch, compose, renderNothing } from 'recompose';
import LoadingComponent from "./LoadingComponent";
var enhancer = compose(branch(function (_ref) {
  var loading = _ref.loading;
  return !loading;
}, renderNothing));
export default enhancer(LoadingComponent);